<template>
  <div class="my-2">
    <div
      v-if="company"
      class="card"
      style="background: #eeeeee"
    >
      <div class="card-body p-2">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="media align-items-center">
              <img
                class="rounded-circle user-image border mr-2"
                :src="getPhoto(company.logo,'thumbnailCropped')"
                alt=""
                style="width: 60px"
              >
              <div class="about">
                <div class="name f-w-600">
                  {{ company.name }} {{ getCompanyFormat(company.format) }}
                </div>
                <div class="status">
                  {{ company.taxId }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            {{ $t('companyForms.satnalmaReytinqi') }} <br>
            <a
              style="cursor: pointer"
              @click.prevent="$emit('openProcurementRating', company.id)"
            >
              <StarRatingView
                :count="company.procurementRateCount"
                :total="company.procurementRateTotal"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="filteredForms.length<1">
      <div class="alert alert-info">
        {{ $t('companyForms.axtaraUyunDyrlndirmFormuTaplmad') }}
      </div>
    </div>
    <div
      v-for="f in filteredForms"
      class="card"
      style="background: #dddddd"
    >
      <div class="card-body">
        <p class="lead form-weight-bold">
          {{ f.name }}
        </p>
        <div
          v-for="sector in f.sectors"
          :key="sector.id"
        >
          - {{ sector.sector.name }}
        </div>

        <div
          v-if="requestMap[f.id]"
          class="mt-3"
        >
          <CompanyFormRequestStatus :status="requestMap[f.id].status" />
          <br>
          <br>
          <router-link
            class="btn btn-sm btn-primary"
            target="_blank"
            :to="{name: 'vendorManagementOutgoingRequests', query: {request: requestMap[f.id].id}}"
          >
            {{ $t('companyForms.mracitBax') }}
          </router-link>
        </div>
        <div
          v-else
          class="mt-3"
        >
          <router-link
            class="btn btn-sm btn-primary"
            target="_blank"
            :to="{name: 'vendorFormView', params:{id: f.id}}"
          >
            {{ $t('companyForms.mracitEt') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCompanyForms
} from "@/repositories/VendorManagementRepository";
import {mapState} from "vuex";
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import StarRatingView from "@/pages/scc/utils/StarRatingView.vue";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";

export default {
  name: 'CompanyForms',
  components: {CompanyFormRequestStatus, StarRatingView},
  props: {
    companyId: {},
    sectors: {
      default: () => []
    },
  },
  data() {
    return {
      forms: [],
      requests: [],
      company: null
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      profile: state => state.auth.profile,
    }),
    filteredForms() {
      if(this.sectors.length>0 && this.profile === 'SUPPLIER') {
        return this.forms.filter(form => {
          return form.sectors.some(formSector => {
            return this.sectors.some(sector => sector.id === formSector.sector.id);
          });
        });

      } else {
        return this.forms;
      }
    },
    requestMap() {
      let map = {};
      this.requests.forEach(r => {
        map[r.companyFormId] = r;
      });
      return map;
    }
  },

  mounted() {
    this.getCompanyForms();
  },

  methods: {

    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getCompanyForms() {
      getCompanyForms(this.token, this.companyId).then(({forms, my_requests, company}) => {
        this.forms = forms;
        this.requests = my_requests;
        this.company = company;
      })
    },
  },
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
